import { DateTime } from 'luxon'

/**
 * Formats send-invitation history `created_at` for display.
 * API value is event-timezone wall clock as `YYYY-MM-DD HH:mm:ss` (e.g. `2026-09-13 08:18:04`).
 * Output: `MMM DD, YYYY · HH:MM AM/PM` (e.g. `Sep 13, 2026 · 08:18 AM`).
 */
export function formatInvitationHistoryDate(createdAt: string): string {
  const raw = createdAt?.trim()
  if (!raw) return ''

  const parsed = DateTime.fromSQL(raw)
  if (!parsed.isValid) return raw

  return parsed.toFormat('MMM dd, yyyy · hh:mm a')
}
